import { ChainId } from 'symbiosis-js-sdk'

export const sisTokenKeys = {
	balance: (chainId: ChainId, account: string) =>
		['sis-token', 'balance', chainId, account] as const,
	allowance: (chainId: ChainId, account: string) =>
		['sis-token', 'allowance', chainId, account] as const,
	availableToClaim: (chainId: ChainId, account: string) =>
		['sis-token', 'available-to-claim', chainId, account] as const,
}

export const sisLockKeys = {
	totalOverview: (chainId: ChainId) =>
		['sis-lock', 'overview', chainId] as const,
	details: (chainId: ChainId, account: string) =>
		['sis-lock', 'details', chainId, account] as const,
	newDetails: (chainId: ChainId) =>
		['sis-lock', 'new-details', chainId] as const,
	changeDetails: (chainId: ChainId, account: string) =>
		['sis-lock', 'change-details', chainId, account] as const,
}
